import { yup } from '@guiker/shared-framework'

import { AgreementFeeType } from '../../../../entity'

export const rentalFeeSchema = yup.object({
  type: yup
    .string()
    .oneOf([AgreementFeeType.PERCENTAGE, AgreementFeeType.RENT_GUARANTEE])
    .default(AgreementFeeType.PERCENTAGE)
    .required(),
  value: yup.number().required(),
})
